module.exports = __webpack_public_path__ + "img/labmemtest_btn_download_en.c4a6c445.png";